import { Form } from 'react-bootstrap';
import { useFormContext, Controller } from 'react-hook-form';


export default function RHTextarea({ name, label, helperText, required, rows, InputProps, ...other }) {
    const { control } = useFormContext();
    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => (
                <>
                    <Form.Label htmlFor={name} className="form-label">{label}{required && <span className="text-danger">*</span>}</Form.Label>


                    <textarea className={`form-control  ${error?.message && 'is-invalid'}`} id={name} {...field} {...other} {...InputProps} rows={rows || 1} ></textarea>
                    <div className="invalid-feedback">{error?.message}</div>


                </>
            )}
        />
    );
}
